<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <div ot class="box bg-purple-dark"></div>
            <div ot class="box bg-purple"></div>
            <div ot class="box bg-purple-light"></div>
            <div ot class="box bg-purple"></div>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%20class%3D%22box%20bg-purple-dark%22%3E%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%20class%3D%22box%20bg-purple%22%3E%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%20class%3D%22box%20bg-purple-light%22%3E%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cdiv%20ot%20class%3D%22box%20bg-purple%22%3E%3C%2Fdiv%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20scoped%3E%0A.box%20%7B%0A%20%20%20%20width%3A%20100px%3B%0A%20%20%20%20height%3A%2030px%3B%0A%7D%0A.bg-purple-dark%20%7B%0A%20%20background%3A%20%2399a9bf%3B%0A%7D%0A.bg-purple%20%7B%0A%20%20background%3A%20%23d3dce6%3B%0A%7D%0A.bg-purple-light%20%7B%0A%20%20background%3A%20%23e5e9f2%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style scoped>
.box {
    width: 100px;
    height: 30px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
</style>

